module.exports = __webpack_public_path__ + "img/beam-body-5.1d21cdb7.png";